import { Decamelized } from 'humps';

export enum OnboardingFunnelStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum OnboardingFunnelStepStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum OnboardingFunnelStep {
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  GROUPS = 'GROUPS',
  EMPLOYEES = 'EMPLOYEES',
  MANAGE_EMPLOYEES = 'MANAGE_EMPLOYEES',
  INVOICE_SETTINGS = 'INVOICE_SETTINGS',
  BILLING = 'BILLING',
}

export type OnboardingFunnelStepsStatus = Record<
  string,
  OnboardingFunnelStepStatus
>;

export interface OnboardingFunnelDetails {
  funnelStatus: OnboardingFunnelStatus;
  funnelSteps: OnboardingFunnelStepsStatus;
  dateCreated: string;
  dateUpdated: string;
}

export type OnboardingFunnelDetailsResponse =
  Decamelized<OnboardingFunnelDetails>;
